import { useTranslation } from "react-i18next";
import type { Tournament } from "@/campaigns/modules/tournament/types";
import { tournamentLabels } from "@/campaigns/modules/tournament/labels";
import { CampaignFinishedCard } from "@/components/campaign-card/campaign-finished-card";
import { CampaignDockPanel } from "@/components/campaigns/campaign-shell/campaign-dock-panel";
import { TournamentBoard } from "./tournament-board";
import { TournamentNextPrize } from "./tournament-next-prize";

/**
 * A tournament in the overlay's dock column: the detail view's sections at
 * dock density — the board (the player's standing and the rows around them)
 * and the next prize with the join state. The board's header already counts
 * the players. Once it is over, the detail view's finished card leads and the
 * board stands as the final result, with nothing left to play for.
 */
export const TournamentDockPanel = ({
  tournament,
  joined,
}: {
  tournament: Tournament;
  joined: boolean;
}) => {
  const { t } = useTranslation();
  const finished = tournament.campaign.status === "FI";

  return (
    <CampaignDockPanel minimumBet={tournament.minimum_bet}>
      {finished && (
        <CampaignFinishedCard
          campaign={tournament.campaign}
          title={tournamentLabels(tournament, t).finished}
        />
      )}
      <TournamentBoard
        campaignId={tournament.campaign.id}
        joined={joined}
        density="dock"
      />
      {!finished && (
        <TournamentNextPrize tournament={tournament} joined={joined} />
      )}
    </CampaignDockPanel>
  );
};
